export default {
    data () {
        return {
            popoverResult: {
                list: [],
            }
        }
    },
    methods: {
        beforeShowPopover (data, url = '/arrangeExam/getPaperScore.api', key = 'id', $event) {
            let params = {}
            params[key] = data.id
            if (this.ajax) {
                this.source.cancel('取消未返回的请求')
            }
            let CancelToken = this.$axios.CancelToken
            this.source = CancelToken.source()
            this.oneScoreList = []
            this.$set(data, 'loading', true)
            this.ajax = this.$axios.get(url, {
                params: params,
                cancelToken: this.source.token,
                'X-loadingOff': 'off',
            }).then(res => {
                this.ajax = null
                this.popoverResult = res.result
                this.showPopover(data, $event)
                this.$set(data, 'loading', false)
            }).catch(err => {
                this.$set(data, 'loading', false)
            })
        },
        hidePopover (data) {
            if (this.ajax) {
                this.source.cancel('取消未返回的请求')
            }
            data.isPopoverShow = false
            this.$nextTick(() => {
                const doms = document.querySelectorAll('.tooltip-status-popover')
                doms.forEach((item, index) => {
                    item.remove()
                })
            })
            this.$set(data, 'isPopoverShow', false)
        },
        showPopover (data, $event) {
            this.$set(data, 'isPopoverShow', true)
            this.$nextTick(() => {
                const doms = document.querySelectorAll('.tooltip-status-popover')
                doms.forEach((item, index) => {
                    if (index !== doms.length - 1) item.style.display = 'none'
                })
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/manualPopoverMixin.js